<template>
    <v-card>
        <v-card-title>
            <v-layout justify-space-around wrap>
              <v-flex xs1>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      color="primary"
                      small
                      @click="function () {
                        if (step === 1) $emit('fechar')
                        else if (step === 2) step = 1
                      }"
                    >
                      <v-icon>{{step !== 1 ? 'arrow_back' : 'close'}}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{step !== 1 ? 'Voltar' : 'Fechar'}}</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs9>
                <h1 class="text-xs-center">{{titulo}}</h1>
              </v-flex>
              <v-tooltip bottom v-if="step===1">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    color="primary"
                    small
                    @click="step = 2"
                  >
                    <v-icon>history</v-icon>
                  </v-btn>
                </template>
                <span>Histórico de Pagamentos</span>
              </v-tooltip>
              <v-spacer v-else></v-spacer>
            </v-layout>
        </v-card-title>
        <v-alert
            :value="true"
            type="error"
            style="font-size: 1.2em"
            class="pa-2"
            v-if="alerta"
        >
              Usuário não encontrado
        </v-alert>
        <v-divider></v-divider>
        <v-card-text>
          <v-stepper v-model="step" style="box-shadow:none;">
            <v-stepper-items>
              <v-stepper-content step="1" class="pa-0 ma-0">
                <v-select
                  v-model="is_rede"
                  :loading="loading"
                  :items="[
                    { text: 'Assinatura do Posto', value: false },
                    { text: 'Assinatura da Rede', value: true }
                  ]"
                  item-text="text"
                  item-value="value"
                  box
                  outline
                  color="primary"
                  label="Selecione uma opção"
                />
                <v-tabs
                  v-model="tabs"
                  grow
                  color="transparent"
                  slider-color="primary"
                >
                  <v-tab>Por ID</v-tab>
                  <v-tab>Por CPF</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabs">
                  <v-tab-item lazy>
                    <v-text-field
                        v-if="tabs == 0"
                        v-model="id_pessoa"
                        :loading="loading"
                        box
                        outline
                        color="primary"
                        label="Digite o ID do usuário"
                    />
                  </v-tab-item>
                  <v-tab-item lazy>
                    <v-text-field
                        v-if="tabs == 1"
                        v-model="cpf"
                        :loading="loading"
                        box
                        outline
                        color="primary"
                        label="Digite o CPF do usuário"
                        mask="###.###.###-##"
                    />
                  </v-tab-item>
                </v-tabs-items>
                <v-card v-if="pessoa" elevation="4" class="ma-4">
                  <v-card-title class="justify-center">
                    <h3>INFORMAÇÕES DO USUÁRIO</h3>
                  </v-card-title>
                  <v-divider verfical></v-divider>
                  <v-card-text>
                    <h3 class="mb-3" style="font-weight: normal;">Nome: <b>{{ pessoa.nome }}</b></h3>
                    <h3
                      class="mb-3"
                      style="font-weight: normal;"
                    >
                      É Assinante: <b>{{ inscricao && inscricao.tem_assinatura && !inscricao.assinatura.cancelado ? 'SIM': 'NÃO' }}</b>
                    </h3>
                    <template v-if="inscricao && inscricao.assinatura">
                      <h3
                        class="mb-3"
                        style="font-weight: normal;"
                      >
                        Data da Próxima Cobrança: <b :class="`${ new Date() >= new Date(`${inscricao.assinatura.data_cobranca}T23:59:59`) ? 'error' : 'success'}--text`">{{  inscricao.assinatura.data_cobranca | formatDate('DD/MM/YYYY') }}</b>
                      </h3>
                      <h3
                        class="mb-3"
                        style="font-weight: normal;"
                      >
                        Data de Encerramento: <b :class="`${new Date() >= new Date(`${inscricao.assinatura.data_encerramento}T23:59:59`) ? 'error' : 'success'}--text`">{{ inscricao.assinatura.data_encerramento | formatDate('DD/MM/YYYY') }}</b>
                      </h3>
                      <h3
                        class="mb-3 error--text"
                        style="font-weight: normal;"
                        v-if="inscricao.assinatura.plano.id_gerencianet"
                      >
                        Essa Assinatura não pode ser paga no estabelecimento.
                      </h3>
                      <h3
                        v-if="inscricao.assinatura.plano.vinculado_veiculo && inscricao.assinatura.veiculo"
                        class="mb-3"
                        style="font-weight: normal;"
                      >
                          Veiculo Vinculado: <b>{{ inscricao.assinatura.veiculo.marca }} {{ inscricao.assinatura.veiculo.modelo }}</b>
                      </h3>
                    </template>
                  </v-card-text>
                  <v-divider verfical></v-divider>
                  <v-card-actions
                    class="justify-center white--text"
                    v-if="inscricao && inscricao.assinatura"
                    :style="{ 'background-color':  new Date() >= new Date(`${inscricao.assinatura.data_encerramento}T23:59:59`) ? 'red' : 'green' }"
                  >
                    <h2>
                      Valor: <b>{{ inscricao.assinatura.plano.valor | currency({fractionCount:  2}) }}</b>
                    </h2>
                  </v-card-actions>
                </v-card>
                <v-select
                  v-model="tipo_pagamento"
                  :loading="loading"
                  :items="tipos_pagamentos"
                  item-text="descricao"
                  item-value="id_tipo_pagamento"
                  box
                  outline
                  color="primary"
                  label="Selecione o tipo de pagamento"
                />
                <v-select
                  v-if="!inscricao || !inscricao.tem_assinatura"
                  v-model="plano"
                  :loading="loading"
                  :items="planos.filter(p => !!p.rede == is_rede)"
                  box
                  outline
                  item-value="id"
                  color="primary"
                  label="Selecione o plano de assinatura"
                  return-object
                >
                  <template v-slot:item="props">
                    <v-layout wrap full-width style="width: 100%;">
                      <v-flex xs3>
                        Plano: {{ props.item.intervalo > 1 ? 'Anual' : 'Mensal' }}
                      </v-flex>
                      <v-flex xs6 style="justify-content: center; display: flex;">
                        Para {{ props.item.rede ? `a Rede ${ props.item.rede.nome }` : `o Posto ${ props.item.posto.nome_fantasia }` }}
                      </v-flex>
                      <v-flex xs3>
                        Valor: {{ props.item.valor | currency({ fractionCount: 2 }) }}
                      </v-flex>
                    </v-layout>
                  </template>
                  <template v-slot:selection="props">
                    <v-layout wrap full-width style="width: 100%;">
                      <v-flex xs3>
                        Plano: {{ props.item.intervalo > 1 ? 'Anual' : 'Mensal' }}
                      </v-flex>
                      <v-flex xs6 style="justify-content: center; display: flex;">
                        Para {{ props.item.rede ? `a Rede ${ props.item.rede.nome }` : `o Posto ${ props.item.posto.nome_fantasia }` }}
                      </v-flex>
                      <v-flex xs3>
                        Valor: {{ props.item.valor | currency({ fractionCount: 2 }) }}
                      </v-flex>
                    </v-layout>
                  </template>
                </v-select>
                <v-select
                  v-if="pessoa && ((plano && plano.vinculado_veiculo) || (inscricao && inscricao.assinatura && inscricao.assinatura.plano.vinculado_veiculo))"
                  v-model="id_veiculo"
                  :loading="loading"
                  :items="veiculos"
                  box
                  outline
                  item-value="id_veiculo"
                  color="primary"
                  label="Selecione o veiculo para vincular a assinatura"
                >
                  <template v-slot:item="props">
                    {{ props.item.marca }} {{ props.item.modelo }}
                  </template>
                  <template v-slot:selection="props">
                    {{ props.item.marca }} {{ props.item.modelo }}
                  </template>
                </v-select>
              </v-stepper-content>
              <v-stepper-content step="2" class="pa-0 ma-0">
                <v-layout justify-center>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    lazy
                    transition="slide-y-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn flat small v-on="on">
                        <span class="secondary--text headline font-weight-medium">{{date}}</span>
                      </v-btn>
                    </template>
                    <v-date-picker v-model="new_date" no-title scrollable color="primary" locale="pt-br"></v-date-picker>
                  </v-menu>
                  <v-spacer></v-spacer>
                  <v-text-field
                    label="ID do usuário"
                    solo
                    type="number"
                    v-model="id_pessoa"
                    color="primary"
                  />
                  <v-spacer></v-spacer>
                </v-layout>
                <v-list three-line class="pt-0">
                  <template v-for="(venda, index) in vendas">
                    <v-divider v-if="index > 0" :key="`${index}div`" inset></v-divider>
                    <v-list-tile
                      avatar
                      :key="`${index}l`"
                    >
                      <v-list-tile-content style="width: 40%;">
                        <v-list-tile-title>{{ venda.cliente.pessoa.nome_completo }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          class="grey--text text--darken-3 caption font-weight-medium"
                        >
                          ID do Usuário:
                          {{ venda.cliente.pessoa.id_pessoa }}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title
                          class="grey--text text--darken-3 caption font-weight-medium"
                          >
                            Data de venda:
                            {{
                              venda.data_compra.split("-").reverse().join("/")
                            }}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title
                          class="grey--text text--darken-3 caption font-weight-medium"
                          >
                            Código:
                            {{
                              venda.codigo
                            }}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title
                          class="grey--text text--darken-3 caption font-weight-medium"
                          >
                            Forma de pagamento:
                            {{
                              venda.tipo_pagamento
                            }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-content>
                        <v-list-tile-sub-title
                          class="grey--text text--darken-3 caption font-weight-medium"
                          >
                            Recebido por:
                            {{
                               venda.frentista ? venda.frentista.nome : 'Sistema Apetrus'
                            }}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title
                          class="grey--text text--darken-3 caption font-weight-medium"
                          v-if="venda.frentista"
                        >
                            Matrícula:
                            {{
                              venda.frentista.matricula
                            }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-list-tile-title>
                          <b class="light-green--text lighten-1">{{ venda.valor_total | currency({ fractionCount: 2 }) }}</b>
                        </v-list-tile-title>
                      </v-list-tile-action>
                    </v-list-tile>
                  </template>
                </v-list>
                <v-layout justify-space-between v-if="vendas.length > 0">
                  <v-flex xs1>
                    <v-btn
                      icon
                      small
                      @click="pagination.page--"
                      color="primary"
                      :disabled="pagination.page == 1"
                    >
                    <v-icon>arrow_back</v-icon>
                  </v-btn>
                  </v-flex>
                  <v-flex xs9>
                    <v-layout justify-center>
                      <v-avatar>
                        <v-btn icon small color="primary">
                          {{pagination.page}}
                        </v-btn>
                      </v-avatar>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      icon
                      small
                      @click="pagination.page++"
                      :disabled="pagination.page == pages"
                      color="primary"
                    >
                      <v-icon>arrow_forward</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
        <v-card-text v-if="step===1">
            <v-layout justify-space-around wrap class="mb-2">
                <v-flex xs9>
                    <h6
                        class="mb-2 text-xs-center"
                        style="
                            font-size: 1.1em;
                            margin-left: 9em;
                        "
                    >
                        Digite o PIN do frentista responsável
                    </h6>
                </v-flex>
                <v-flex xs2>
                    <v-icon size="40">engineering</v-icon>
                </v-flex>
                <v-flex xs10>
                    <h4>Lido por: {{frentista.nome}}</h4>
                    <h4>Matricula: {{frentista.matricula}}</h4>
                </v-flex>
            </v-layout>
            <Pin v-if="!autenticado" :frentista="frentista" @autenticado="autenticado = true"/>
            <h3 v-else class="success--text text-xs-center mt-3 mb-3">A leitura já pode ser realizada</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="step === 1"
            color="primary"
            block
            class="mb-1"
            :disabled="!(cpf || id_pessoa) || !tipo_pagamento || !(plano || inscricao)"
            @click="PagarOrRealizarAssinatura"
          >
            <v-icon class="mr-1">search</v-icon>
            {{ inscricao && inscricao.tem_assinatura ? 'Realizar Pagamento' :  'Realizar Assinatura' }}
          </v-btn>
          <h2 v-else class="text-xs-center mb-3 gray--text" style="width: 100%;">
            Total de Vendas: {{ total_vendas | currency({ fractionCount: 2 }) }}
          </h2>
        </v-card-actions>
    </v-card>
</template>

<script>

import Pin from '@/components/Pin'

export default {
  components: { Pin },
  data: () => ({
    date: new Date().toLocaleDateString(),
    new_date: new Date().toISOString().substr(0, 10),
    menu: false,
    step: 1,
    inscricao: undefined,
    pesquisa: undefined,
    id_pessoa: undefined,
    totalItens: 0,
    tipo_pagamento: undefined,
    tabs: 0,
    cpf: undefined,
    total_vendas: 0,
    tipos_pagamentos: [],
    autenticado: false,
    pessoa: null,
    alerta: false,
    vendas: [],
    planos: [],
    veiculos: [],
    plano: undefined,
    is_rede: false,
    id_veiculo: undefined,
    pagination: {
      rowsPerPage: 5,
      page: 1
    }
  }),
  beforeMount () {
    this.pegarTiposDePagamento()
    this.pegarPlanos()
    if (this.step === 4) this.pagamentosDeAssinatura()
  },
  computed: {
    titulo () {
      return this.step === 1 ? 'Assinatura do Usuário' : 'Pagamentos de Assinatura'
    },
    loading () {
      return this.$store.getters.loading
    },
    tem_assinatura () {
      if (!this.inscricao) return false
      else if (!this.inscricao.assinatura) return false
      else if (this.inscricao.assinatura.cancelado) return false
      return true
    },
    pages () {
      let count = this.totalItens
      if (this.pagination.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.pagination.rowsPerPage)
    },
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    frentista () {
      return this.$store.getters.frentista
    }
  },
  watch: {
    pagination: {
      handler (val, oldval) {
        if (this.step === 2) this.pagamentosDeAssinatura()
      },
      deep: true
    },
    step (val) {
      if (val === 2) this.pagamentosDeAssinatura()
    },
    tabs () {
      this.pesquisa = undefined
    },
    id_pessoa (val) {
      if (val) {
        if (this.step === 1) this.pegarPessoaPorId(false)
      } else {
        this.pessoa = undefined
      }
      if (this.step === 4) this.pagamentosDeAssinatura()
    },
    cpf (val) {
      if (val && val.length === 11) {
        if (this.step === 1) this.pegarPessoaPorId(true)
      } else {
        this.pessoa = undefined
      }
    },
    new_date (val) {
      this.menu = false
      if (val) {
        this.formatDate(val)
        this.pagamentosDeAssinatura()
      }
    },
    frentistaSelecionado (val) {
      if (val) {
        this.pagamentosDeAssinatura()
      }
    },
    pessoa (val) {
      if (val) {
        this.pegarInscricao()
        this.pegarVeiculosAssinatura()
      } else {
        this.inscricao = undefined
        this.veiculos = []
        this.id_veiculo = undefined
      }
    },
    is_rede (val) {
      if (this.pessoa) {
        this.pegarInscricao()
      }
    }
  },
  methods: {
    formatDate (date) {
      this.date = date
        .split('-')
        .reverse()
        .join('/')
    },
    pegarTiposDePagamento () {
      this.$store.dispatch('pegarTiposDePagamento').then(json => {
        this.tipos_pagamentos = json.filter((tp) => tp.referencia !== 'carteira_digital' && tp.referencia !== 'cashback')
      })
    },
    pegarPessoaPorId (isCPF) {
      const data = {
        id_frentista: this.frentistaSelecionado.id_frentista
      }

      if (isCPF) data.cpf = this.cpf
      else data.id_pessoa = this.id_pessoa

      this.$store.dispatch('pegarPessoaPorId', data).then(json => {
        this.alerta = false
        this.pessoa = json
      }).catch(() => {
        this.alerta = true
        this.pessoa = undefined
      })
    },
    pagamentosDeAssinatura () {
      const data = {
        id_frentista: this.frentista.id_frentista,
        page: this.pagination.page,
        data_compra: this.new_date,
        total: true,
        page_size: this.pagination.rowsPerPage,
        metodo_pagamento: 'pospago'
      }
      if (this.id_pessoa) data.cliente__pessoa__id_pessoa = this.id_pessoa
      this.$store.dispatch('pagamentosDeAssinatura', data).then(json => {
        this.vendas = json.results.compras
        this.total_vendas = json.results.valor_total
        this.totalItens = json.count
      })
    },
    pegarPlanos () {
      this.$store.dispatch('pegarPlanos', {
        id_gerencianet__isnull: true
      }).then(json => {
        this.planos = json
      })
    },
    pegarInscricao () {
      this.inscricao = undefined
      const data = {
        id_frentista: this.frentista.id_frentista
      }
      if (this.cpf) data.cpf = this.cpf
      else if (this.id_pessoa) data.id_pessoa = this.id_pessoa
      data.isRede = this.is_rede
      this.$store.dispatch('gereciarAssinatura', {
        method: 'GET',
        parametros: data
      }).then(json => {
        this.inscricao = json
      })
    },
    PagarOrRealizarAssinatura () {
      const data = {
        id_frentista: this.frentista.id_frentista
      }
      if (this.cpf) data.cpf = this.cpf
      else if (this.id_pessoa) data.id_pessoa = this.id_pessoa
      if (this.tem_assinatura) {
        data.id_assinatura = this.inscricao.assinatura.id
        data.isRede = !!this.inscricao.assinatura.rede
      } else {
        data.id_plano = this.plano.id
      }
      data.id_tipo_pagamento = this.tipo_pagamento
      if (this.id_veiculo) data.id_veiculo = this.id_veiculo
      this.$store.dispatch('gereciarAssinatura', {
        method: this.tem_assinatura ? 'PUT' : 'POST',
        body: data
      }).then(() => {
        this.inscricao = undefined
        this.pessoa = undefined
        this.plano = undefined
        this.cpf = undefined
        this.id_pessoa = undefined
        this.tipo_pagamento = undefined
      })
    },
    pegarVeiculosAssinatura () {
      this.$store.dispatch('pegarVeiculosAssinatura', {
        id_pessoa: this.id_pessoa
      }).then(json => {
        this.veiculos = json
      })
    }
  }
}
</script>
